import React, { type JSX } from "react";
import InlineResultsTabs from "../../InlineResultsTabs_Component";
import BotMessageContent from "./BotMessageContent";
import ChatFactFooter from "./ChatFactFooter";
import { FeedbackControls } from "./ChatMessageParts";

export interface BotMessageBodyProps {
  message: any;
  index: number;
  allFacts: any[];
  allDocuments: any[];
  onDocumentClick: (document: any) => void;
  isLatestBot: boolean;
  feedbackChoice?: "thumbs_up" | "thumbs_down";
  isScaling: boolean;
  onFeedback: (index: number, feedbackType: "thumbs_up" | "thumbs_down") => void;
}

/** The bot message body: streamed text, results, sources and feedback. */
export default function BotMessageBody({
  message,
  index,
  allFacts,
  allDocuments,
  onDocumentClick,
  isLatestBot,
  feedbackChoice,
  isScaling,
  onFeedback,
}: BotMessageBodyProps): JSX.Element {
  return (
    <div>
      <div className="text-sm sm:text-base leading-relaxed break-words text-cvc-text">
        {/* Phase 7: Use new BotMessageContent component with useStreamingMessage hook */}
        <BotMessageContent message={message} allFacts={allFacts} allDocuments={allDocuments} />
      </div>
      {/* Inline results (deals + research docs) — rendered per-turn when feature flag is on */}
      <InlineResultsTabs turnId={message.turnId} />
      {/* Fact footer - shows source documents referenced in this message */}
      <ChatFactFooter
        message={message}
        onDocumentClick={onDocumentClick}
        allFacts={allFacts}
        allDocuments={allDocuments}
      />
      {/* Feedback controls - only for the latest bot message with a turnId */}
      {isLatestBot && message.turnId && (
        <FeedbackControls
          index={index}
          chosen={feedbackChoice}
          scaling={isScaling}
          onFeedback={onFeedback}
        />
      )}
    </div>
  );
}
